import {
  Injectable,
} from '@angular/core';
import {
  CanDeactivate,
  UrlTree,
} from '@angular/router';
import {
  BoardingPassesModel,
  selectBoardingPassesEntities,
} from '@des/store/boarding-passes';
import {
  JourneyAlternativeOffersStore,
  selectJourneyAlternativeOffersIsPendingStatus,
} from '@des/store/journey-alternative-offers';
import {
  JourneyModel,
  JourneysStore,
  selectJourneysEntities,
} from '@des/store/journeys';
import {
  RegulatoryDetailsReplyDataModel,
  RegulatoryDetailsStore,
  selectRegulatoryDetailsEntities,
} from '@des/store/regulatory-details';
import {
  SeatmapModel,
  SeatmapsStore,
  selectSeatmapsEntities,
} from '@des/store/seatmaps';
import {
  Dictionary,
} from '@ngrx/entity';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  combineLatest,
  Observable,
} from 'rxjs';
import {
  filter,
  map,
  take,
} from 'rxjs/operators';

/**
 * Accept the routing when no store are pending
 */
@Injectable()
export class StoresPendingGuard implements CanDeactivate<any> {
  constructor(private readonly store: Store<JourneysStore & RegulatoryDetailsStore & SeatmapsStore & JourneyAlternativeOffersStore>) {}

  public canDeactivate(): Observable<boolean | UrlTree> {
    return combineLatest(
      this.store.pipe(
        select(selectJourneysEntities),
        map(isEntitiesPending)
      ),
      this.store.pipe(
        select(selectSeatmapsEntities),
        map(isEntitiesPending)
      ),
      this.store.pipe(
        select(selectRegulatoryDetailsEntities),
        map(isEntitiesPending)
      ),
      this.store.pipe(
        select(selectBoardingPassesEntities),
        map(isEntitiesPending)
      ),
      this.store.pipe(
        select(selectJourneyAlternativeOffersIsPendingStatus)
      )
    ).pipe(
      filter((arePending: boolean[]) => arePending.every((isPending) => !isPending)),
      take(1),
      map(() => true)
    );
  }
}

/**
 * @param entities
 */
function isEntitiesPending(entities: Dictionary<JourneyModel | SeatmapModel | RegulatoryDetailsReplyDataModel | BoardingPassesModel>): boolean {
  return Object.values(entities).some((entity) => !!entity && !!entity.isPending);
}
